import fetch from 'isomorphic-unfetch';
import { logout } from '../redux/actions/member';
import { store } from '../utils/store';
import { has } from 'lodash';

export const apiUrl = window.apiUrl || `${window.location.origin}/api`;

// https://stackoverflow.com/questions/68595638/react-redux-middleware-cannot-access-variable-defined-in-utils

class FetchError extends Error {
  constructor(res) {
    super(res.statusText); // (1)
    this.name = 'FetchError'; // (2)
    this.res = res;
    try {
      this.res.data = res.json().catch((e) => {
        console.error(e);
      });
    } catch (e) {
      this.res.data = Promise.resolve({});
    }
  }
}

export function getAPIUrl() {
  return window.apiUrl || `${window.location.origin}/api`;
}

export const storeing = store;
export const redirectToLogin = () => {
  if (window.location.pathname !== '/login') {
    const state = store.getState();
    const member = state.member.member;

    if (has(member, 'member_id')) {
      console.debug('Firing logout at redirect to Login', member);
      logout(member.member_id, member.session_id)(store.dispatch);
    }
  }
};

const handleGenericResponse = (res) => {
  if (res.ok) {
    try {
      if (res.headers.get('content-length') === '0') {
        return Promise.resolve();
      }
      return res.json();
    } catch (e) {
      return res;
    }
  }
  console.error(res);
  // if the API returns a 401, redirect to login
  if (res.status === 401) {
    return Promise.reject(redirectToLogin());
  }
  let error = new FetchError(res);

  console.error(error);
  console.error(res);
  return Promise.reject(error);
};

export const GET = (url, option = {}) => {
  return fetch(url, {
    method: 'GET',
    headers: option,
  })
    .then(handleGenericResponse)
    .catch((err) => {
      console.error('Fetch error');
      console.error(err);
      return Promise.reject(err);
    });
};

export const POST = (url, data, option = {}) =>
  fetch(url, {
    method: 'POST',
    body: data,
    headers: option,
  }).then(handleGenericResponse);

export const PUT = (url, data, option = {}) =>
  fetch(url, {
    method: 'PUT',
    body: data,
    headers: option,
  }).then((res) => {
    if (res.ok) {
      try {
        if (res.headers.get('content-length') === '0') {
          return Promise.resolve();
        }
        return res.json();
      } catch (e) {
        return res;
      }
    }
    console.log('Failed.');
    // if the API returns a 401, redirect to login
    if (res.status === 401) {
      return redirectToLogin();
    }

    let error = new Error(res.statusText);
    error.res = res;
    console.error(error);
    console.error(res);
    return Promise.reject(error);
  });

export const DELETE = (url, data, option = {}) =>
  fetch(url, {
    method: 'DELETE',
    body: data,
    headers: option,
  }).then((res) => {
    if (res.ok) {
      try {
        if (res.headers.get('content-length') === '0') {
          return Promise.resolve();
        }
        return res.json();
      } catch (e) {
        return res;
      }
    }

    console.log('Failed.');
    // if the API returns a 401, redirect to login
    if (res.status === 401) {
      return redirectToLogin();
    }

    let error = new Error(res.statusText);
    error.res = res;
    try {
      error.res.data = res.json().catch((e) => {
        console.error(e);
      });
    } catch (e) {
      error.res.data = {};
    }
    console.error(error);
    console.error(res);
    return Promise.reject(error);
  });
